function setRegistrationStepError({ state, input }) {
  let path = `client.registrating.current.${state.get('client.currentPage')}`
  let current = state.get(path)
  if (!input.result.errors) {
    return
  }
  input.result.errors.forEach(error => {
    let field = state.get(`${path}.${error.key}`)
    let validations = field.validations || []
    let errorMessages = field.errorMessages || []
    let length = errorMessages.length
    const key = `bus-client.${error.errorMessage}`
    if (
      error.errorHandler === 'notEqualTo' &&
      validations.indexOf(`notEqualTo:"${current[error.key].value}"`) === -1
    ) {
      state.set(`${path}.${error.key}`, {
        ...field,
        validations: [
          `notEqualTo:"${current[error.key].value}"`,
          ...validations
        ],
        errorMessages: [{ key }, ...errorMessages],
        isValid: false,
        errorMessage: { key }
      })
      state.push('app.customErrors', {
        path: `${path}.${error.key}`,
        index: length
      })
    } else {
      state.merge(`${path}.${error.key}`, {
        isValid: false,
        errorMessage: { key }
      })
    }
  })
}

export default setRegistrationStepError



// WEBPACK FOOTER //
// ./src/modules/login/actions/setRegistrationStepError.js